import { render, staticRenderFns } from "./AssignedStockProducts.vue?vue&type=template&id=6546ce4c&"
import script from "./AssignedStockProducts.vue?vue&type=script&lang=js&"
export * from "./AssignedStockProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports